import ky from 'ky';

const placesBaseUrl = (process.env.NEXT_PUBLIC_GG_PLACES_URL || 'https://places.googleapis.com/v1').replace(/\/$/, '');

export const placesKyClient = ky.create({
  prefix: `${placesBaseUrl}/`,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        const apiKey = process.env.NEXT_PUBLIC_GG_PLACES_KEY;
        if (apiKey) {
          request.headers.set('X-Goog-Api-Key', apiKey);
        }
      },
    ],
  },
});
